import { combineReducers } from "redux";
import meetingSchedularReducer from "./schedular/reducer";

const rootReducers = combineReducers({
  meetingSchedularReducer: meetingSchedularReducer,
});

export default rootReducers;
